const namespace = 'course';
// 修改是否在购物车
export const CHANGE_IN_SHOPPING_CART = "changeInShoppingCart";
export const COMMIT_CHANGE_IN_SHOPPING_CART = `${namespace}/${CHANGE_IN_SHOPPING_CART}`;

// 修改视频播放时间
export const CHANGE_CURRENT_TIME = "changeCurrentTime";
export const COMMIT_CHANGE_CURRENT_TIME = `${namespace}/${CHANGE_CURRENT_TIME}`;
